export const UPDATE_CAMPAIGNS_STATE = "UPDATE_CAMPAIGNS_STATE"
export const MODIFY_CAMPAIGNS_STATE = "MODIFY_CAMPAIGNS_STATE"
export const DELETE_CAMPAIGNS_RECORD = "DELETE_CAMPAIGNS_RECORD"
export const UPDATE_CAMPAIGN_DETAILS_STATE = "UPDATE_CAMPAIGN_DETAILS_STATE"
export const UPDATE_CAMPAIGN_STATUS = "UPDATE_CAMPAIGN_STATUS"
export const UPDATE_CAMPAIGNS = "UPDATE_CAMPAIGNS"